import Pusher from 'pusher-js'
import Echo from 'laravel-echo'
import { appConfig } from '@/configs/appConfig.js'
import { useAuthStore } from '@/store/auth.js'
import { useLanguageStore } from '@/store/language.js'

export const InitUserMixin = {
  data() {
    return {
      authStore: null,
      localeStore: null
    }
  },
  computed: {
    user() {
      return this.authStore?.getUser
    },
    isAuthenticated() {
      return this.authStore?.isAuthenticated()
    }
  },
  created() {
    this.authStore = useAuthStore()
    this.localeStore = useLanguageStore()
  },
  async mounted() {
    await this.authStore.fetchUser()
    if (this.authStore?.user?.locale) {
      this.localeStore.setLocale(this.authStore.user?.locale)
    }
    this.startWebSocketListeners()
  },
  unmounted() {
    this.stopWebSocketListeners()
  },
  methods: {
    startWebSocketListeners() {
      if (!this.isAuthenticated || !this.user) {
        return
      }
      window.Pusher = Pusher

      /** @type {import('laravel-echo')} */
      window.Echo = new Echo({
        broadcaster: 'pusher',
        key: appConfig.wsKey,
        cluster: appConfig.wsCluster,
        wsHost: appConfig.wsHost,
        wsPort: appConfig.wsPort,
        wssPort: appConfig.wsPort,
        forceTLS: (appConfig.wsProtocol ?? 'https') === 'https',
        enabledTransports: ['ws', 'wss'],
        authEndpoint: appConfig.baseURL + '/broadcasting/auth',
        auth: {
          headers: {
            Authorization: 'Bearer ' + this.authStore.getToken()
          }
        }
      })
      window.Echo.private(`Notification.${this.user.slug}`)
        .listen('.chat_message_new', ({ room }) => {
          this.alertsStore.increment()
          this.chatsStore.onRoomMessageReceived(room)
        })
        .listen('.chat_messages_read', ({ room, count }) => {
          if (!this.isChatPage && this.$route.params.slug !== room) {
            this.alertsStore.subtract(count)
            this.chatsStore.onRoomMessagesRead({ room, count })
          }
        })
        .listen('.chat_message_deleted', ({ room }) => {
          this.alertsStore.decrement()
          this.chatsStore.onRoomMessageDeleted(room)
        })
        .listen('.chat_messages_dialog_created', ({ room }) => {
          this.chatsStore.onRoomDialogCreated(room)
        })
        .listen('.chat_messages_dialog_handled', ({ room }) => {
          if (room.count > 0) {
            this.chatsStore.onRoomDialogHandel(room)
          }
        })
    },
    stopWebSocketListeners() {
      if (window.Echo && this.user) {
        window.Echo.private(`Notification.${this.user.slug}`)
          .stopListening('.chat_message_new')
          .stopListening('.chat_messages_read')
          .stopListening('.chat_message_deleted')

        window.Echo.leave(`Notification.${this.user.slug}`)

        window.Echo.disconnect()

        delete window.Echo
      }
      window.Echo = null
    }
  }
}
